import { Message, MessageProps } from './Message'
import { MessageError } from './MessageError'

export * from './MessageError'
export type { MessageProps }

type MessageWithVariantsType = {
  Error: typeof MessageError
} & typeof Message
const MessageWithVariants = Message as MessageWithVariantsType
MessageWithVariants.Error = MessageError

export { MessageWithVariants as Message }
